import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const SMART_CREATE_MODAL_CLIENT_ID: ClientId = client('smart-create-modal');
